<script setup>
import { useStore } from 'vuex';
import { PhxIcon } from '@phx-styleguides/iwc';

defineProps({
  links: {
    type: Array,
    required: true,
  },
});

const store = useStore();

const logout = () => {
  store.dispatch('currentUser/logout');
};

const linkComponent = (link) => {
  return link.isLogout ? 'button' : 'a';
};

const linkAttributes = (link) => {
  return link.isLogout
    ? {
        type: 'button',
        onClick: logout,
      }
    : {
        href: link.link,
        target: link.openInNewTab ? '_blank' : null,
      };
};
</script>

<template>
  <ul class="accordion stack stack--spacing-2">
    <li v-for="link in links" :key="link.title">
      <component
        :is="linkComponent(link)"
        v-bind="linkAttributes(link)"
        :data-cy="link.dataCy"
        class="btn btn--icon accordion__toggle"
      >
        <span class="btn__text">{{ link.title }}</span>

        <span class="btn__icon btn__icon--end">
          <phx-icon icon="chevron-right" bidirectional class="icon--sm" />
        </span>
      </component>
    </li>
  </ul>
</template>
